import { createFileRoute, notFound, Link } from "@tanstack/react-router";
import { getInfluencer, INFLUENCERS } from "@/lib/growth/influencerRegistry";
import { InfluencerHero } from "@/components/growth/InfluencerHero";
import { InfluencerStatsPanel } from "@/components/growth/InfluencerStatsPanel";
import { InfluencerPowerScore } from "@/components/growth/InfluencerPowerScore";
import { WhatsAppGrowthCTAs } from "@/components/growth/WhatsAppGrowthCTAs";
import { TelegramCtaCard } from "@/components/growth/TelegramCtaCard";
import { StateTeamsLeaderboard } from "@/components/growth/StateTeamsLeaderboard";
import { BrasilHub } from "@/components/match/brasil/BrasilHub";

export const Route = createFileRoute("/brasil/influencer/$slug")({
  loader: ({ params }) => {
    const inf = getInfluencer(params.slug);
    if (!inf) throw notFound();
    return inf;
  },
  head: ({ params }) => {
    const inf = INFLUENCERS[params.slug?.toLowerCase() ?? ""];
    const name = inf?.displayName ?? params.slug;
    const url = `https://versesport.com/brasil/influencer/${params.slug}`;
    const title = `Entre para a torcida de ${name} — VerseSport Brasil`;
    const desc = `Comunidade ${name} no VerseSport: previsões, Nation Wars, ranking e missões exclusivas.`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: InfluencerPage,
  notFoundComponent: InfluencerNotFound,
  errorComponent: ({ error }) => (
    <main className="mx-auto max-w-3xl p-4 text-sm text-muted-foreground">
      Erro ao carregar a página: {error.message}
    </main>
  ),
});

function InfluencerPage() {
  const inf = Route.useLoaderData();
  return (
    <main className="mx-auto max-w-3xl space-y-3 px-3 py-4">
      <InfluencerHero influencer={inf} />
      <InfluencerStatsPanel influencer={inf} />
      <InfluencerPowerScore influencer={inf} />
      <WhatsAppGrowthCTAs influencerSlug={inf.slug} nationCode={inf.country} />
      <TelegramCtaCard country={inf.country} />
      <StateTeamsLeaderboard country={inf.country} />
      <BrasilHub />
      <p className="px-1 text-[10px] leading-snug text-muted-foreground">
        VerseSport não é endossado oficialmente por {inf.displayName}. Página de comunidade
        para fãs da torcida — marcas e nomes mencionados pertencem a seus respectivos titulares.
      </p>
    </main>
  );
}

function InfluencerNotFound() {
  return (
    <main className="mx-auto max-w-3xl space-y-3 px-3 py-4 text-center">
      <h1 className="text-xl font-black">Influencer não encontrado</h1>
      <p className="text-sm text-muted-foreground">Esta torcida ainda não existe no VerseSport.</p>
      <Link to="/brasil" className="inline-block rounded-lg bg-primary px-3 py-2 text-xs font-black text-primary-foreground">
        Voltar para VerseSport Brasil
      </Link>
    </main>
  );
}